/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-08-05 15:44:52
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-03-03 19:12:38
 */
import { post, get } from "../http/request";
const baseUrl = process.env.VUE_APP_API_URL;

// 下载中心列表
export const downloadList = {
  reqList: (params) =>
    post(`/web/export-operate/exportExcelList`, params),
  // 文件流下载
  downloadFile: (params) =>
    post(`/web/export-operate/downloadFile`, params, { responseType: "arraybuffer" })
};
// i18
export const I18n_api = (params) =>
  get(`/i18n/dictionary/getDefaultLang`, params);
export const getlanglist = (params) => get(`/i18n/dictionary/getLang`, params);
export const getSysInternationalList = (params) =>
  get(`/i18n/sysInternational/getSysInternationalList`, params);

// 登录 1
export const login = (params) => post(`/web/staff/login`, params);
/* 修改密码 */
export const updatePwd = (parmas) => post(`/web/staff/changePwd`, parmas)
/* 忘记密码 */
export const forgetPwd = (params) => post(`/web/staff/forgetPassword`, params)
/* 获取图形验证码 */
export const getCaptcha = (params) => get(`/web/captcha`, params)
/* 发送短信验证码 */
export const sendCode = (params) => post(`/web/smsRecord/sendSmsCaptcha`, params)
// 退出登录
export const loginOut = (params) => get(`/web/staff/loginOut`, params);
/* 寄件下单 */
export const sendOrderApi = {
  /* 体积重量计算 */
  getVolumeWeight: (params) => post(`/web/send-parcel/getVolumeWeight`, params),
  /* 计算总运费 */
  getTotalCostMoney: (params) => post(`/web/send-parcel/batchTotalCostMoneyNew`, params),
  /* 保存订单 */
  saveOrderSinngle: (params) => post(`/web/send-parcel/saveOrder`, params),
  saveOrder: (params) => post(`/web/send-parcel/batchAddSendParcel`, params),
  getServiceType: (params) => get(`/web/send-parcel/getServiceTypeByCompanyCode`, params),
  /* 计算优惠金额 */
  caluAiscountAmount: (params) => post(`/web/send-parcel/discountAmountPreCalculateForBatchAddSendParcel
`, params)
}
/* 客户管理 */
export const customerManagementApi = {
  reqList: (params) => post(`/web/customerManager/queryCustomer`, params),
  /* 删除用户信息 */
  deleteData: (params) => post(`/web/customerManager/delCustomer`, params),
  /* 地址解析 */
  smartParse: (params) => post(`/web/send-parcel/smartParse`, params),
  /* 新增寄（收）件人信息 */
  addCustomer: (params) => post(`/web/customerManager/addCustomer`, params),
  /* 编辑寄（收）件人信息 */
  editCustomer: (params) => post(`/web/customerManager/editCustomer`, params),
  /* 通过id查询寄件人信息 */
  viewById: (params) => get(`/web/customerManager/queryById`, params),
  /* 核查实名制信息 */
  checkRealName: (params) => get(`/web/customerManager/checkRealName`, params),
  /* 查询实名详情信息 */
  queryRealNameByMobile: (params) => get(`/web/customerManager/queryRealNameByMobile`, params),
  /* 添加实名制信息 */
  addRealName: (params) => post(`/web/customerManager/addRealName`, params),
  /* 根据手机号查历史地址信息 */
  queryInfoByPhone: (params) => post(`/web/customerManager/queryInfoByPhone`, params),
  /* 根据寄件人匹配收件人 */
  matchRecipient: (params) => post(`/web/customerManager/matchRecipient`, params),
  /* 返回用于实名制的二维码地址 */
  getQRCodeAddress: (params) => get(`/web/customerManager/getQRCodeAddress`, params),
  /* 校验H5是否已经完成上次二维码的实名制 */
  checkIsCompletedForH5RealName: (params) => post(`/web/customerManager/checkIsCompletedForH5RealName`, params)
}

/* 订单列表 */
export const orderApi = {
  reqList: (params) => post(`/web/send-parcel/orderList`, params),
  /* 订单列表详情 */
  viewUrl: `/web/send-parcel/sendParcelDetail`,
  details: (params) => get(`/web/send-parcel/sendParcelDetail`, params),
  // 导出
  reqExcel: (params) => post(`/web/send-parcel/export`, params, { responseType: "arraybuffer" }),
  // 异步导出
  exportParcelAsync: (params) => post(`/web/send-parcel/exportAsync`, params),
  /* 查询合作快递公司 */
  expressList: (params) => post(`/web/send-parcel/listExpress`, params),
  /* 打印面单 */
  print: (params) => post(`/web/send-parcel/printFaceSheet`, params),
  /* 打印面单添加记录 */
  addRecord: (params) => post(`/web/send-parcel/addRecord`, params),
  /* 获取物品类型 */
  goodType: (params) => post(`/web/send-parcel/goodsTypes`, params),
  /* 获取驿站所在区域地址信息 */
  getSiteAddress: (params) => post(`/web/customerManager/getSiteAddress`, params),
  /* 取消寄件 */
  cancalSendOrder: (params) => post(`/web/send-parcel/cancelOrderById`, params),
  /* 根据id获取再来一单信息 */
  getReInfoById: (params) => get(`/web/send-parcel/getReInfoById`, params),
  /* 打印回执小票 */
  printReceipt: (params) => post(`/web/send-parcel/printReceipt`, params),
  /**打印合并回执小票 */
  batchPrintReceipt: (params) => post(`/web/send-parcel/batchPrintReceipt`, params),
  getSource: (params) => get(`/web/send-parcel/source`, params)

}

export const OnlinePaymentApi = {
  searchBalance: (params) => get(`/web/online-pay/queryBalance`, params),
  /* 获取支付二维码 */
  onlineQrCode: (params) => post(`/web/online-pay/generateQrCode`, params),
  /* 轮询查询付款状态 */
  pollingStatus: (params) => post(`/web/online-pay/polling`, params),
  /* 主动查询付款状态 */
  queryPaymentStatus: (params) => post(`/web/online-pay/inquiryPaymentStatus`, params),
  /* 充值记录 */
  reqList: (params) => post(`/web/online-pay/paymentRecord`, params)
}

export const consumableApi = {
  reqList: (params) => post(`/web/consumables/pageConsumablesVO`, params),
  /* 新增包材 */
  addConsumables: (params) => post(`/web/consumables/addConsumables`, params),
  /* 编辑包材 */
  editConsumables: (params) => post(`/web/consumables/updateConsumables`, params),
  /* 删除包材 */
  deleteConsumables: (params) => post(`/web/consumables/delConsumables`, params)
}

/* 消息盒子 */
export const searchMessageApi = {
  /* 查询列表 */
  reqList: (params) => get(`/web/homePage/selectUnreadMessage`, params),
  /* 改变未读消息的状态 */
  changeUnreadMessageStatus: (params) => post(`/web/homePage/changeUnreadMessageStatus`, params)
}
/* 首页 */
export const homeApi = {
  /* 数据看板 */
  selectDataKanban: (params) => post(`/web/homePage/selectDataKanban`, params),
  /* 公告列表 */
  selectNoticeList: (params) => get(`/web/homePage/selectNoticeList`, params),
  /* 公告详情 */
  selectNoticeDetail: (params) => get(`/web/homePage/selectNoticeDetail`, params),
  /* 订单趋势 */
  selectOrderTrend: (params) => post(`/web/homePage/selectOrderTrend`, params),
  /* 营收趋势 */
  selectRevenueTrend: (params) => post(`/web/homePage/selectRevenueTrend`, params)

}
/* 资金管理-预付款-变动明细查询 */
export const changeDetailApi = {
  reqList: (params) => post(`/web/billDetail/changedDetailList`, params),
  reqExcel: (params) => post(`/web/billDetail/changedDetailListExport`, params, { responseType: 'arraybuffer' }),
  // 异步导出
  exportParcelAsync: (params) => post(`/web/billDetail/changedDetailListExportAsync`, params)
}
/* 对账单*/
export const accountStatementApi = {
  reqList: (params) => post(`/web/billDetail/checkBill`, params),
  reqExcel: (params) => post(`/web/billDetail/checkBillExport`, params, { responseType: 'arraybuffer' }),
  // 异步导出
  exportParcelAsync: (params) => post(`/web/billDetail/checkBillAsyncExport`, params)
}
// 上传图片
export const uploadImage = `${baseUrl}/web/image/upload?isPersistence=true`;
export const uploadApi = {
  // 上传
  getUploadUrl: (params) => post(`/admin/image/uploadAndDownloadCloudUrl`, params),
}
// 寄件人选择所在地区-收件人选择所在地区(寄件下单页面)
export const pageLocation = (params) => post(`/web/tab-towndz/pageLocation`, params);

/** 数据字典*/
export const DictApi = {
  getSwitchValue: (params) => get(`/web/dict/getSwitchValue`, params)
}
// 解密
export class decryptApi {
  // 解密 key：寄件订单传id 
  // code 001：反查订单表寄件人手机号 002：反查订单表收件人手机号  003：反查订单表下单人手机号 004：反查订单表寄件人身份证号
  // menuName 菜单名称（中文）
  static decrypt (params) {
    return post(`/web/sensitive/decrypt`, params)
  }
}
